import './EpisodeListItem.scss'

import React from 'react'

import LinkWithImage from '../../components/LinkWithImage'
import CCLanguages from '../../components/CCLanguages'

import { getSizedImageUrl } from '../../utils/misc'
import { DEFAULT_IMAGE_SIZE } from '../../constants/images'

interface Props {
  title: string
  link: string
  imageUrl: string
  videoDuration: number
  synopsis: string
  ccLanguages: string[]
}

export default function EpisodeListItem({ title, link, imageUrl, videoDuration, synopsis, ccLanguages }: Props) {
  return (
    <li>
      <LinkWithImage
        className="EpisodeListItem"
        link={link}
        imageUrl={getSizedImageUrl(imageUrl, DEFAULT_IMAGE_SIZE.WIDTH, DEFAULT_IMAGE_SIZE.HEIGHT)}
        alt={title}
        videoDuration={videoDuration}
        nativeLink
      >
        <div className="EpisodeListItem__description">
          <h3 className="EpisodeListItem__title">{title}</h3>
          <p className="EpisodeListItem__synopsis">{synopsis}</p>
          <CCLanguages ccLanguages={ccLanguages} />
        </div>
      </LinkWithImage>
    </li>
  )
}
